import Vue from 'vue'
import VModal from 'vue-js-modal'
import VueCookies from 'vue-cookies'
import VuePlyr from 'vue-plyr'

import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
// Init plugin


import axios from 'axios'

import App from './App.vue'
import store from '../store'
import router from './router'
import vuetify from './plugins/vuetify';

Vue.use(Loading);


Vue.use(VModal, {
  dynamic: true
})

Vue.use(VuePlyr, {
    plyr: {}
})

Vue.use(VueCookies)
VueCookies.config('2d')

axios.defaults.headers.common['X-CSRFToken'] = document.getElementsByName("csrfmiddlewaretoken")[0].value;

const base_url = '/';

const instance = axios.create({
  baseURL: base_url
});


Vue.prototype.$setCookie = (cookieName, cookieValue) => {
  Vue.prototype.$cookies.set(cookieName, cookieValue);
}

Vue.prototype.$getCookie = (cookieName) => {
  return Vue.prototype.$cookies.get(cookieName);
}

Vue.config.productionTip = false
export default instance

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')

instance.interceptors.response.use((req) => {
  return req;
}, (e) => {
  store.dispatch('sendStackTrace', JSON.stringify(e.response));
  return Promise.reject(e);
});

//Errors from a script from a different source have no detail,
//handle them separately. This code is from the mozilla docs
window.onerror = function (msg, url, lineNo, columnNo, error) {
  let errString;
  let string = msg.toLowerCase();
  const substring = "script error";
  if (string.indexOf(substring) > -1) {
    errString = {
      "Normal Javascript Error": substring
    };
  } else {
    errString = {
      'Message': msg,
      'URL': url,
      'Line': lineNo,
      'Column': columnNo,
      'error': JSON.stringify(error.stack)
    }

  }
  store.dispatch('sendStackTrace', JSON.stringify(errString));
  return false;
};


Vue.config.errorHandler = Vue.config.errorHandler = function (err) {
  const errString = {
    "Stack error": `${err.stack}`
  };
  //console.error(err.stack);
  store.dispatch('sendStackTrace', JSON.stringify(errString));
  return false;
};